<template>
    <div class="m-pass">
        <h5 class="title"></h5>
        <div class="slogen">
            <p>情义积分累计达到一定程度后可领取奖励</p>
        </div>

        <div class="page-view">
            <div class="pass-panel">
                <div class="score-info">
                    <div class="score-title"></div>
                    <div class="score-data">
                        <span v-if="$store.state.userinfo.score && $store.state.userinfo.score['0']">{{ $store.state.userinfo.score['0'].score }}</span>
                        <span v-else>0</span>  
                    </div>
                </div>

                <div class="pass-list">
                        <div class="pass-item" v-for="(item,index) in task_list" :key="index" :class="{'dismiss' : (giftRate) > index  , 'act' : index < (finishRate) && index >= (giftRate),'next' : index == finishRate }">
                                <div class="pass-wrapper">
                                    <div class="reward-item">
                                    <div class="r-wrapper">
                                        <div class="pic" v-tips="item.giftList[0].giftId">
                                            <game-item :locked="true" :id="item.giftList[0].giftId" :num="item.giftList[0].sendNum"></game-item>
                                        </div>
                                    </div>
                                </div>

                                <div class="item-name">{{ item.giftList[0].giftName }}</div> 
                                
                                <div class="score-cnt">{{ item.value }}</div>
                            </div>
                        </div>

                </div>

                <div class="bar">
                    <div class="bar-body" v-if="$store.state.userinfo.score && $store.state.userinfo.score['0']" :style="{'width' : calc_pro(finishRate,rate)}"></div>
                    <div class="bar-body" v-else :style="{'width' : '0' + '%'}"></div>
                </div>

                <div class="pass-data"></div>

                <div class="u-btn apply" @click="apply()"></div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.title{
    width: 808px;
    height: 190px;
    margin: 0 auto 20px;
    background-image: url(~@/assets/images/pc/title-4.png);
}


.pass-panel{
    position: relative;
    width: 1389px;
    height: 638px;
    margin: 20px auto 0;
    box-sizing: border-box;
    /* background-image: url(~@/assets/images/pc/bg-pass.png); */
}

.score-title{
    width: 287px;
    height: 34px;
    margin: 0 auto;
    background-image: url(~@/assets/images/pc/t-score.png); 
}

.score-data{
    text-align: center;
    font-size: 40px;
    color: #ffe489;
    margin-bottom: 56px;
}

.u-btn.apply{
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 239px;
    height: 84px;
    margin-left: -119.5px;
    background-image: url(~@/assets/images/pc/btn-pass_apply.png); 
}

.pass-list{
    display: flex;
    justify-content: space-between;
    padding: 0 100px;
    margin-bottom: 85px;
}

.pass-item{
    position: relative;
}

.pass-item .pass-wrapper{
    position: relative;
    width: 130px;
    height: 183px;
    padding-top: 35px;
    box-sizing: border-box;
    background-image: url(~@/assets/images/pc/pass-item.png); 
}

.pass-item.act .pass-wrapper{
    position: relative;
    width: 130px;
    height: 183px;
    padding-top: 25px;
    box-sizing: border-box;
    background-position: center;
    background-image: url(~@/assets/images/pc/pass-item_act.png); 
}

.pass-item.next{
    margin-top: -48px;
}

.pass-item.next .pass-wrapper{
    position: relative;
    width: 154px;
    height: 217px;    
    padding-top: 50px;
    box-sizing: border-box;
    background-image: url(~@/assets/images/pc/pass-item_next.png);
    z-index: 4;
}

.pass-item.next::before{
    content: '';
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 252px;
    height: 271px;
    margin-top: -12px;
    transform: translate(-50%,-50%);
    background-image: url(~@/assets/images/pc/layer-pass-back.png);    
}

.pass-item.dismiss::before{
    content: '';
    display: block;
    position: absolute;
    top: 212px;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    height: 42px;
    background-image: url(~@/assets/images/pc/label-dismiss.png);
    z-index: 2;
}

.pass-item::after{
    content: '';
    display: block;
    position: absolute;
    left: 50%;
    bottom: -19px;
    transform: translateX(-50%);
    border-top: 6px solid #0db490;
    border-right: 6px solid transparent;
    border-left: 6px solid transparent;    
}

.score-cnt{
    position: absolute;
    left: 50%;
    bottom: -174px;
    transform: translateX(-50%);
    color: #ffe489;
    font-size: 24px;
    text-align: center;
}

.pass-item.act .score-cnt{
    bottom: -150px;
}

.pass-item.next .score-cnt{
    font-size: 28px;
    bottom: -194px;
}

.bar{
    position: relative;
    width: 1200px;
    height: 17px;
    margin: 0 auto;
    background-image: url(~@/assets/images/pc/pass-bar.png);
}

.bar-body{
    position: absolute;
    left: 2px;
    top: 50%;
    width: 1196px;
    height: 15px;
    margin-top: -8px;
    /* background-image: url(~@/assets/images/pc/pass-exp.png); */
    background-color: #216763;
    border-radius: 10px;
}

.reward-item{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 70px;
    height: 70px;
    margin: 0 auto 15px;
    background-image: url(~@/assets/images/pc/bg-item.png);
}

.pass-item.next .reward-item{
    background-image: url(~@/assets/images/pc/bg-item_2.png);
}

.r-wrapper{
    position: relative;
    width: 46px;
    margin: 0 auto;
}

/* .pass-item.dismiss .r-wrapper::after{
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 46px;
    height: 46px;
    background-color: rgba(0, 0, 0, 0.8);
    background-image: url(~@/assets/images/pc/icon-get.png);
    background-repeat: no-repeat;
    background-position: center;
} */

.r-wrapper .pic{
    width: 46px;
    height: 46px;
}

.item-name{
    padding: 0 8px;
    font-size: 14px;
    color: #49392e;
    text-align: center;
}

.pass-item.act .item-name{
    padding: 0 20px;
}

.pass-item.next .item-name{
    padding: 0 25px;
}

</style>

<script>
export default {
    data(){
        return {
            task_list : [],
            scroll_left : 0,
            tid : '',
            rate : 0,
            finishRate : 0,
            giftRate : 0,
        }
    },
    mounted(){
        this.render();
    },
    methods : {
        calc_pro(parse,total){
            let left = 0;
            let config = [100,300,600,1200,1800,2400,3000];
            let way = config.indexOf(total) > -1 ? 0 : 1;

            if(parse > 0 && parse != 10){
                left = 80 + (parse - 1) * 175 + way * 100 + 'px';
            }

            if(parse == 7){
                left = '1196px';
            }

            return left;
        },          
        render (){
            this.$axios.get(ajax_url_map.task_info,{
                params : {
                    no : 't03',
                    s : true,
                }
            })
            .then(
                res => {
                    this.task_list = res.data[0].subList;
                    this.tid = res.data[0].taskOrderId;
                    this.rate = res.data[0].rate;
                    this.finishRate = res.data[0].finishRate;
                    this.giftRate = res.data[0].giftRate;
                }
            )

            //this.$success_modal({text : '领取成功，奖励已发放至军师邮件，请注意查收。'});
        },   
        apply(){

            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.zid){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }

            let list = [];
            for(var i = this.giftRate; i < this.finishRate;i++){
                var _t = this.task_list[i];

                list.push(_t.giftList[0]);
            }

            this.$axios.post(ajax_url_map.task_apply,{
                orderId : this.tid
            })
            .then(
                res => {
                    this.$success_modal({text : '领取成功，奖励已发放至军师邮件，请注意查收。',giftList : list});
                    this.render();
                    this.$update_user();
                },
                rej => {
                    this.$toast(rej.message);
                }
            )            
        },        
    }    
}
</script>


// WEBPACK FOOTER //
// src/view/pass.vue